import React from 'react';
import { useGetPlatformAdsQuery } from '../../features/api/apiSlice';

const PlatformAdBanner = ({ placement = 'home_banner' }) => {
  const { data: ads = [] } = useGetPlatformAdsQuery({ placement });
  const ad = (ads || []).find((row) => row.is_active !== false) || ads[0];
  if (!ad) return null;

  const inner = (
    <div className="rounded-2xl overflow-hidden border border-slate-200 bg-slate-900 text-white">
      {ad.image_url ? (
        <img src={ad.image_url} alt={ad.title || 'Advertisement'} className="w-full h-40 sm:h-48 object-cover" />
      ) : null}
      <div className="px-4 py-3">
        <p className="text-[10px] uppercase tracking-[0.16em] text-slate-400 font-semibold">Advertisement</p>
        <p className="font-semibold mt-0.5">{ad.title}</p>
        {ad.body ? <p className="text-sm text-slate-300 mt-1">{ad.body}</p> : null}
        {ad.advertiser_name ? <p className="text-xs text-slate-400 mt-1">{ad.advertiser_name}</p> : null}
      </div>
    </div>
  );

  if (ad.link_url) {
    return (
      <a href={ad.link_url} target="_blank" rel="noopener noreferrer" className="block mb-6">
        {inner}
      </a>
    );
  }

  return <div className="mb-6">{inner}</div>;
};

export default PlatformAdBanner;
